import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon41: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M15.5 0C15.776 0 16 0.224 16 0.5V2.003L17.5 2.004C18.881 2.004 20 3.123 20 4.504V17.506C20 18.887 18.881 20.006 17.5 20.006H2.5C1.119 20.006 0 18.887 0 17.506V4.504C0 3.123 1.119 2.004 2.5 2.004L4 2.003V0.5C4 0.224 4.224 0 4.5 0C4.776 0 5 0.224 5 0.5V2.003H15V0.5C15 0.224 15.224 0 15.5 0ZM19 8.02699H1V17.506C1 18.335 1.672 19.006 2.5 19.006H17.5C18.328 19.006 19 18.335 19 17.506V8.02699ZM7.52499 10.341L10 12.816L12.475 10.341C12.67 10.146 12.987 10.146 13.182 10.341C13.377 10.537 13.377 10.853 13.182 11.049L10.706 13.523L13.182 15.998C13.377 16.194 13.377 16.51 13.182 16.705C12.987 16.901 12.67 16.901 12.475 16.705L10 14.23L7.52499 16.705C7.32999 16.901 7.01299 16.901 6.81799 16.705C6.62299 16.51 6.62299 16.194 6.81799 15.998L9.293 13.523L6.81799 11.049C6.62299 10.853 6.62299 10.537 6.81799 10.341C7.01299 10.146 7.32999 10.146 7.52499 10.341ZM4 3.003L2.5 3.004C1.672 3.004 1 3.675 1 4.504V7.02699H19V4.504C19 3.675 18.328 3.004 17.5 3.004L16 3.003V4.5C16 4.776 15.776 5 15.5 5C15.224 5 15 4.776 15 4.5V3.003H5V4.5C5 4.776 4.776 5 4.5 5C4.224 5 4 4.776 4 4.5V3.003Z"
        fill="#A84A76"
      />
    </Icon>
  )
}
